<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <div>
      <textarea id="ck-editor" name="ckeditor" rows="10" cols="80"></textarea>
    </div>
  </div>
</template>
<script>
import CKEDITOR from 'CKEDITOR'
import {baseUrl} from '@/libs/api.request'
import {getToken,
  localSave,
  localRead} from '@/libs/util'

export default {
  name: 'interface_list',
  data() {
    return {
      uploadUrlCk: baseUrl + 'Index/uploadCk',
      uploadUrl: baseUrl + 'Index/upload',
      uploadHeader: {'Api-Auth': getToken()},
    }
  },
  created() {

  },
  mounted() {
    this.initializeEditor()
  },
  methods: {
    initializeEditor () {
      this.editorObj1 = CKEDITOR.replace('ckeditor', {
        language: 'zh-CN',      // Adding drag and drop image upload.
        removeDialogTabs: 'image:advanced;image:Link',
        image_previewText: '  ',
        extraPlugins: 'uploadimage',
        uploadUrl: this.uploadUrlCk,
        filebrowserImageUploadUrl: this.uploadUrlCk,
        filebrowserUploadUrl: this.uploadUrlCk, //服务器上传地址
        removeButtons: 'Save,PasteFromWord,PasteText,Paste,Copy,Replace,Scayt,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,BulletedList,NumberedList,Indent,Outdent,Language,About,ShowBlocks,Flash,Anchor,HorizontalRule,PageBreak,Iframe'
      })

      // 图片上传返回的数据处理
      this.editorObj1.on('fileUploadResponse', function (evt) {
        evt.stop()
        var data = evt.data
        let xhr = data.fileLoader.xhr
        let response = xhr.responseText
        let imgUrl = JSON.parse(response).data.fileUrl
        if (!imgUrl) {
          data.message = '上传出错'   // 这是失败alert提示信息
          evt.cancel()
        } else {
          data.url = imgUrl   // 返回到“图像信息”那里的URL框里面
        }
      })

      //需要手动设置绑定
     // this.extraParams['ad1']=this.editorObj1.getData()
      //this.editorObj1.setData(this.extraParams['ad1'])
    },



  }
}
</script>
